// Whether ONE of the owner's own material rows fits how THIS section is produced -- the single definition the
// Malzeme dropdown (MaterialSelect), the add/manage button label (ManageOwnMaterialsButton) and the "add a
// material first" gate (ManufacturingLineLists#ownMaterialMissing) all read, so the three can never disagree on
// what "a material that fits" means. It mirrors the server-side material score exactly:
//   - carton (Frank::MaterialScores::CartonMaterialUserPrice) splits on the bobbin flag: a row is a bobbin-roll
//     row or a folded-sheet row, so it fits ONLY the matching bobbin state. An ABSENT flag is a NON-bobbin row.
//   - hard cardboard (Frank::MaterialScores::HardCardboardMaterialUserPrice) is built around the dieline's board
//     thickness -- a row WITHIN THICKNESS_MATCH_TOLERANCE_MM of that thickness fits (a stocked size a whole step
//     off is the wrong board), mirroring the scorer's nearest-within-tolerance auto-pick; until the thickness is
//     known, none do.
//   - every other material key has no such split, so every row fits.

// The band within which a stocked board counts as the dieline's -- mirrors the Ruby constant
// Frank::MaterialScores::HardCardboardMaterialUserPrice::THICKNESS_MATCH_TOLERANCE_MM (keep the two in sync). It
// absorbs an inch-converted thickness landing just off a stocked one (1.2954mm vs 1.3mm) while rejecting a whole
// size jump (1.2mm vs 3.0mm), so these surfaces show exactly the board the scorer prices.
export const THICKNESS_MATCH_TOLERANCE_MM = 0.05;

export const materialFitsSection = (material, { materialKey, bobbinEnabled, boardThicknessMm }) => {
  if (materialKey === 'carton_material') {
    return Boolean(material.bobbin_enabled) === Boolean(bobbinEnabled);
  }
  if (materialKey === 'hard_cardboard_material') {
    const hasBoardThickness = boardThicknessMm !== undefined && boardThicknessMm !== null;
    return hasBoardThickness
      && Math.abs(Number(material.thickness_in_mm) - Number(boardThicknessMm)) <= THICKNESS_MATCH_TOLERANCE_MM;
  }
  return true;
};

// The rows of `materials` that fit the section, by the same test above.
export const compatibleMaterials = (materials, criteria) => (
  materials.filter((material) => materialFitsSection(material, criteria))
);

// The filter a material form applies to its frequently-used ("Sık kullanılanlar") system list: hard cardboard is
// narrowed to the boards within tolerance of the drawing thickness, every other material key left whole. Both
// material-form trees (frank MaterialForm and the layout QuoteBuilderForm) build the picker's filter from this, so
// the rule AND its "is the thickness known?" gate live in one place. A boardThicknessMm that is null, undefined or
// 0 (thickness unknown) leaves the list unfiltered.
export const systemItemsThicknessFilter = (materialKey, boardThicknessMm) => (items) => (
  (materialKey === 'hard_cardboard_material' && boardThicknessMm > 0)
    ? compatibleMaterials(items, { materialKey, boardThicknessMm })
    : items
);
